module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.woff?52c4adbc17713d632194ed2359b15505";